import { Button, Divider, Stack, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import TextInput from "../../components/textInput";

import {
  createBanners,
  deleteBanners,
  fetchBanners,
} from "../../services/Banners";
import { constants } from "../../theme/Variables";
import BannerCustomDialog from "./BannersDialog";

const tableHeader = ["Banner_Image", "Created_At", "Actions"];
const displayRows = ["Banner_Image", "created_at", "actions"];

function Banners() {
  const openBannersDialog = useRef();
  const imageBtnRef = useRef();
  const [imgUrl, setImgUrl] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [allBanners, setAllBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleFetchAllBanners();
  }, []);

  const handleFetchAllBanners = async () => {
    try {
      const response = await fetchBanners();
      if (response.status == 201 || response.status == 200) {
        let data = response.data.data;
        setAllBanners(data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      console.log(error, "errorerrorerrorerror");
      handleOpenSnackBar("error", error?.data?.message);
    }
  };

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({ snackType: type, snackMessage: message });
  };

  const handleOpenImageInput = () => {
    imageBtnRef.current.click();
  };

  const handleChangeImage = async (event) => {
    setIsLoading(true);
    const file = event.target.files[0];

    if (!file) {
      setIsLoading(false);
      return;
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;

      img.onload = async () => {
        const { width, height } = img;
        let expHeight = 230;
        let expWidth = 340;

        if (width == expWidth && height == expHeight) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", "znblmci9");
          formData.append("cloud_name", "dhiurzrrx");

          try {
            const options = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            const res = await axios.post(
              `https://api.cloudinary.com/v1_1/dhiurzrrx/image/upload`,
              formData,
              options
            );
            const imageUrl = res.data.secure_url;
            setImgUrl(imageUrl);
            handleOpenSnackBar("success", "Image uploaded successfully!");
          } catch (error) {
            console.error(error);
            handleOpenSnackBar("error", "Image upload failed!");
          }
        } else {
          handleOpenSnackBar(
            "error",
            "Image must have an approximate 230 x 340."
          );
        }

        setIsLoading(false);
      };

      img.onerror = () => {
        handleOpenSnackBar("error", "Invalid image file.");
        setIsLoading(false);
      };
    };

    reader.readAsDataURL(file);
  };

  const handleBannersOperation = async () => {
    if (!imgUrl)
      return handleOpenSnackBar("error", "Please upload image first");

    try {
      setIsLoading(true);
      const response = await createBanners({ imageUrl: imgUrl });
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        handleOpenSnackBar("success", response.data.message);
        openBannersDialog.current.closeDialog();
        setImgUrl("");
        handleFetchAllBanners();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error?.message || "An error occurred");
    }
  };

  const handleOpenDialog = () => {
    openBannersDialog.current.openDialog();
  };

  const handleDeleteBanners = async (id) => {
    console.log(id, "ididididididid123123");

    try {
      setIsLoading(true);
      const response = await deleteBanners(id);
      setIsLoading(false);
      console.log(response, "responseresponse");

      if (response.status == 200 || response.status == 201) {
        handleFetchAllBanners();
        handleOpenSnackBar("success", response.data.message);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.data.message);
      console.log(error, "errorerrorerrorerror");
      setIsLoading(false);
    }
  };

  return (
    <NavigationDrawer>
      <CustomBar title="BANNERS FOR MOBILE-APP" />
      <AppContainer>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems="center"
        >
          <Stack
            direction={{ sm: "row" }}
            width="100%"
            flex={2}
            gap={2}
            justifyContent={{ md: "flex-end" }}
          >
            <Button
              variant="contained"
              onClick={() => handleOpenDialog("add")}
              sx={{ height: 37, width: 100 }}
            >
              Add
            </Button>
          </Stack>
        </Stack>
        <Divider />
        {allBanners.length > 0 ? (
          <DynamicTable
            tableData={allBanners}
            displayRows={displayRows}
            tableHeader={tableHeader}
            handleEdit={(row) => handleOpenDialog("edit", row)}
            handleDelete={handleDeleteBanners}
            showEditAndDelete={true}
            showDelete={true}
            showPagination={true}
          />
        ) : (
          <Typography
            color="black"
            fontSize={14}
            fontWeight={700}
            textAlign="center"
            padding="30px 0"
          >
            No Banners Found!
          </Typography>
        )}
      </AppContainer>
      <Loader isloading={isLoading} />
      <BannerCustomDialog
        ref={openBannersDialog}
        imageBtnRef={imageBtnRef}
        imgUrl={imgUrl}
        setImgUrl={setImgUrl}
        isLoading={isLoading}
        handleOpenImageInput={handleOpenImageInput}
        handleUpload={handleChangeImage}
        handleCreateBanners={handleBannersOperation}
      />
    </NavigationDrawer>
  );
}

export default Banners;
